// extracted by mini-css-extract-plugin
export default {"mobMenu_wrap":"mobMenu_mobMenu_wrap__VpnMb","mobMenu_leftBlock":"mobMenu_mobMenu_leftBlock__7+g0s","mobMenu_rightBlock":"mobMenu_mobMenu_rightBlock__mKrpV"};